import {Selector} from '@ngxs/store';
import {SharedDevicesState} from '@store/shared-devices/shared-devices.state';
import {IResponse} from '@interfaces/response';
import {ISharedDevice} from '@interfaces/shared-devices';
import {SharedDevicesModel} from '@store/shared-devices/shared-devices.model';

export class SharedDevicesSelectors {
  @Selector([SharedDevicesState])
  static getSharedDevices(state: SharedDevicesModel): IResponse<ISharedDevice> | null {
    return state.sharedDevices;
  }

  @Selector([SharedDevicesState])
  static sharedDevicesPerPage(state: SharedDevicesModel): number {
    return state.itemsPerPage;
  }

  @Selector([SharedDevicesState])
  static sharedDevicesCurrentPage(state: SharedDevicesModel): number {
    return state.currentPage;
  }

  @Selector([SharedDevicesState])
  static sharedDevicesSearchStr(state: SharedDevicesModel): string {
    return state.searchParam;
  }

  @Selector([SharedDevicesState])
  static sharedDevicesLoader(state: SharedDevicesModel): boolean {
    return state.loader;
  }
}
